var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNaver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_103444_5149",
    transform: "scale(0.0178571)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_103444_5149",
    width: 56,
    height: 56,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHASURBVHgB7ZrBTcMwFIZ/EySuPRZx8Qhlg3oDOgGwQTZouwFMgJgAmCDdgI6QC2pulCOHyrh2ThBbapM8x/R9UqKor47y6z37vTwHYBiGYY5HBK2FHAHfc3N1B+gRBoXYmmd6NRdLqKr0/ss7vhjL/dkcEsOmNIfyiTwLDNx7TmL4SOOn3GcMCZwiHW59hpBAiWTwrw8hgf8CFpg6LDB1WGDqnKMTsmuoj3WjqRhP4Uq+BsQb1OamedzVBNi9oyUdeXC39ZpUtTJCHhttQn/imHseAFGIXizgimJyaASq0ngjmyECdIuMm6NLEEO7iqpqYSbeGoRESBN65t7GaaAX6N68yUI1TqJXmwdzXoGAmJXMPbT4Qs/0L7C4zF137hc2VG1+7BUCD+pJ3Xr8i82P/UIUojqva1JyCOegeKl7raQQCrSdrycQQ72KTu2iQ0iMNDGnDNUYpdrIzUdJspkTKdEHUkfHdCQwC3lDe37Ow/Mx68TDoe0zjZRQVaMWbhumDgtMHRaYOqcskK7z1R7/s4Y8+IxUEPaDoEYCAuPtJxxIaYpBbxvSL9D1SxScJ0sMjn1Y2l0rFfqUi2EYhmnDDwVTYw9R6QAYAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaver);
export default __webpack_public_path__ + "static/media/naver.737d96d4a4d6ad725442f54e0c15b63b.svg";
export { ForwardRef as ReactComponent };